<template>
  <div>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="close"
        :close-on-click-modal="false">
      <div>
        <el-form ref="form" class="formSty" :inline="true" label-position="top" :model="form" :rules="rules">
          <el-form-item label="退订备注" prop="remarkerr">
            <el-input v-model="form.remarkerr" type="textarea"
                      placeholder="请补充退订信息，包括但不限于开发过程、退订原因等"
                      maxlength="1000"
                      :rows="2" style="width: 446px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
           <el-popconfirm
               title="退订后，此任务将从目标客户列表中删除，是否确定要退订？"
               @confirm="subTask('form')"
           >
          <div class="btn_Sub" slot="reference">提 交</div>
        </el-popconfirm>
        <!--         <div class="btn_Sub" @click="subTask('form')">提 交</div>-->
                  <div class="btn_Clo" @click="close">关 闭</div>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import http from "api/freight";

export default {
  props: {
    currRow: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      form: {
        remarkerr: '',
      },
      rules: {
        remarkerr: [
          {
            required: true,
            message: "请输入退订备注",
            trigger: "blur",
          },
        ],
      },
      dialogVisible: true,
    }
  },
  methods: {
    subTask(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          http
              .cancelReceive({
                id: this.currRow.id,
                remake: this.form.remarkerr
              })
              .then((e) => {
                if (e.code == 200) {
                  this.$message({
                    message: '退订成功',
                    type: 'success',
                  })
                  this.$emit('closeTask', true)
                }
              })
        }
      })
    },
    close() {
      this.$emit('closeTask')
    },
  }
}
</script>
<style lang="stylus" scoped>
.cardMesSty {
  display: flex;
  align-items: center;
}

.changeClass {
  display: flex;

  div {
    width: 74px;
    line-height: 32px;
    border-radius: 2px 0px 0px 2px;
    border: 1px solid #D9D9D9;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    text-align: center;
    font-style: normal;
  }

  .active {
    color: #336EB0;
    border: 1px solid #336EB0;
  }
}

.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  text-align: left;
  font-style: normal;
  align-items: center;
  display: flex;
  margin-top: 24px;
  padding-bottom: 16px;

  i {
    width: 2px;
    height: 14px;
    display: block;
    background: #336EB0;
    margin-right: 10px;
  }
}

.formSty {
  /deep/ .el-form-item__label {
    line-height: 20px;
  }

  /deep/ .el-input--medium .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

/deep/ .el-dialog__body {
  padding: 20px 0 20px 30px;
  border-bottom: 2px solid #EEEEEE;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.btn_Sub {
  width: 64px;
  line-height: 33px;
  background: #336EB0;
  border-radius: 2px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
  padding: 0;
}

.btn_Clo {
  width: 64px;
  line-height: 33px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-style: normal;
  padding: 0;
  margin-left: 8px;
}
</style>
